import { gql } from "@apollo/client";

export const UPSERT_DRAFT = gql`
  mutation UpsertDraft($input: UpsertDraftInput!) {
    upsertDraft(input: $input) {
      _id
      clientId
      client {
        name
        email
        phone
        addresses {
          city
          line1
          line2
          zip
        }
      }
      policyPreviews {
        _id
        plans {
          deductible
          limit
          netPremium
          total
          copay
          coverages {
            coverageGroupId
            limit
            name
          }
          ratingsData {
            preexistingConditions
          }
          fees {
            invoiceLineItemType
            maxInvoicesSpread
            name
            total
            type
            discountName
            discountType
          }
        }
        error {
          message
        }
      }
    }
  }
`;
